<template>
  <div class="match-details">
    <!-- 顶部标签栏 -->
    <div class="card-header">
      <div class="header-tabs">
        <div 
          class="tab-item" 
          :class="{ active: showType === 0 }"
          @click="changeShowType(0)"
        >
          动画直播
        </div>
        <div 
          class="tab-item" 
          :class="{ active: showType === 1 }"
          @click="changeShowType(1)"
        >
          视频直播
        </div>
      </div>
      <div class="header-link" @click="goMachDetail">比赛详情 >></div>
    </div>
    
    <!-- 直播播放器区域 -->
    <div class="player-container">
      <div class="player-wrapper">
        <!-- 动画直播 -->
        <template v-if="showType === 0">
          <iframe 
            v-if="has_anim" 
            :src="matchRef?.animation" 
            class="player-frame"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <div v-else class="no-content-state">
            <div class="no-content-container">
              <div class="no-content-border">
                <span class="no-content-text">暂无动画</span>
              </div>
            </div>
          </div>
        </template>
        
        <!-- 视频直播 -->
        <template v-if="showType === 1">
          <iframe
            v-if="has_video && !isMatchFinished"
            class="player-frame"
            frameborder="0"
            :key="matchRef?.liveFlvUrl"
            id="iframe_video"
            :src="playerUrl"
          />
          <div v-else class="no-content-state">
            <div class="no-content-container">
              <div class="no-content-border">
                <span class="no-content-text">{{ isMatchFinished ? '比赛已结束' : '暂无视频' }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 底部标签切换 -->
    <div class="tab-container">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ active: activeTab === index }"
        @click="setActiveTab(index)"
      >
        {{ tab.name }}
        <div v-if="activeTab === index" class="underline"></div>
      </div>
    </div>
    <div class="chat">
      <component
        :is="tabs[activeTab].key"
        :chatId="chatId"
        :key="activeTab === 0 ? chatId : undefined"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, onUnmounted, markRaw, nextTick, computed } from 'vue'
import { getMatchFootballDetailAPI } from '@/api/match'
import MatchChat from './MatchChat.vue'

import { useRouter } from 'vue-router'
import Lineup from '@/views/scoreFootball/components/lineup.vue'
import Exponent from '@/views/scoreFootball/components/exponent.vue'
import MatchResult from '@/views/scoreFootball/components/matchResult.vue'
import { getWebPlayerUrl } from '@/config/playerConfig'

// 计算播放器URL
const playerUrl = computed(() => getWebPlayerUrl())

const tabs = ref([
  { name: '聊球', key: markRaw(MatchChat) },
  { name: '赛况', key: markRaw(MatchResult) },
  { name: '阵容', key: markRaw(Lineup) },
  { name: '指数', key: markRaw(Exponent) }
  // 赛况 阵容 指数
])

//  { name: '关键事件', key: markRaw(FootballCriticalIncident) },
const activeTab = ref(0)
const props = defineProps({
  match: Object
})
const chatId = ref('')
const matchData = ref(null)
const matchRef = ref(null)
const showType = ref(0)
const has_anim = ref(false)
const has_video = ref(false)
let video_iframe_timer = null

// 计算属性：判断比赛是否已结束（status === 3 表示已结束）
const isMatchFinished = computed(() => {
  // 优先使用 matchRef 的 status
  if (matchRef.value?.status === 3) {
    return true
  }
  // 兼容其他可能的状态字段
  if (matchData.value?.status === 3) {
    return true
  }
  return false
})

const router = useRouter()
const video_iframe_timer_count = ref(0)
const goMachDetail = () => {
  if (!matchData.value?.match_id) {
    console.warn('比赛数据不存在')
    return
  }
  router.push(`/score-detail?id=${matchData.value.match_id}&type=${matchData.value.sportId}`)
}

const changeShowType = (type) => {
  showType.value = type
  switch (type) {
    case 0:
      break
    case 1: {
      if (!has_video.value || isMatchFinished.value) {
        return
      }
      const data = {
        playAddr: {
          flv: matchRef.value.liveFlvUrl,
          m3u8: matchRef.value.liveM3u8Url,
          DPlayerID: 'iFrame_Player'
        }
      }
      console.log(data, 'data')
      sendMessageToIframe(data)
      video_iframe_timer = setInterval(function () {
        sendMessageToIframe(data)
      }, 1000)
      break
    }
  }
}
const sendMessageToIframe = (data) => {
  var iframe = document.querySelectorAll('iframe')[0]
  if (iframe) {
    iframe.contentWindow.postMessage(data, '*')
    iframe.onload = function () {
      console.log(iframe)
      iframe.contentWindow.postMessage(data, '*')
    }
  } else {
    console.log('Iframe not found')
  }
}

window.addEventListener('message', function (event) {
  if (event.data.msg === 'playing') {
    if (video_iframe_timer) {
      clearInterval(video_iframe_timer)
    }
  }
})

const setActiveTab = (index) => {
  activeTab.value = index
}
const showHandle = () => {}
const getData = async (matchid) => {
  try {
    if (!matchid) {
      console.warn('⚠️ 无效的 matchid')
      return
    }

    const res = await getMatchFootballDetailAPI({ matchId: matchid.toString() })
    if (res.code === 200) {
      matchRef.value = res.data
      
      // 判断比赛是否已结束（status === 3）
      const isFinished = res.data.status === 3
      
      has_anim.value = false
      has_video.value = false

      // ✅ 从 API 返回中提取 chatId（优先级：chatId > room_id > match_id）
      const extractedChatId = res.data.chatId || res.data.room_id || res.data.match_id
      if (extractedChatId) {
        chatId.value = String(extractedChatId)  // 确保转换为字符串
        console.log('✅ 聊天室ID已设置:', chatId.value)
      } else {
        console.warn('⚠️ 无法从API返回中获取聊天室ID')
      }

      if (res.data.animation) {
        has_anim.value = true
        showType.value = 0
      }
      
      // 只有比赛未结束且有视频地址时才显示视频
      if (!isFinished && res.data.liveFlvUrl) {
        has_video.value = true
        showType.value = 1
        nextTick(() => {
          console.log(matchRef.value, 'matchRef.value')
          // 播放视频
          const data = {
            playAddr: {
              flv: matchRef.value.liveFlvUrl,
              m3u8: matchRef.value.liveM3u8Url,
              DPlayerID: 'iFrame_Player'
            }
          }
          sendMessageToIframe(data)
        })
      } else if (isFinished) {
        console.log('⚠️ 比赛已结束，不加载视频播放器')
      }
    }
  } catch (error) {
    console.error('❌ 获取足球比赛详情失败:', error)
  }
}

watch(
  () => props.match,
  (newMatch) => {
    if (!newMatch || !newMatch.match_id) {
      console.warn('⚠️ match数据无效:', newMatch)
      return
    }
    console.log('📨 收到新的match数据:', newMatch.match_id)
    matchData.value = newMatch
    // chatId 将在 getData 成功后从 API 返回中设置
    getData(newMatch.match_id)
  },
  { immediate: true }  // ✅ 立即执行，确保初始化时也能获取数据
)

watch(
  () => isMatchFinished.value,
  (finished) => {
    if (finished) {
      has_video.value = false
      if (showType.value === 1) {
        // 比赛结束后切回动画标签，避免残留播放器画面
        showType.value = 0
      }
      if (video_iframe_timer) {
        clearInterval(video_iframe_timer)
        video_iframe_timer = null
      }
    }
  }
)

watch(
  () => activeTab.value,
  (newTab) => {
    if (newTab === 0) {
      // 聊球 tab
      console.log('🔄 切换到聊球tab，当前chatId:', chatId.value)
      // chatId 已经在 getData 中设置，不需要重复设置
    }
  }
)

onUnmounted(() => {
  if (video_iframe_timer) {
    clearInterval(video_iframe_timer)
  }

  window.removeEventListener('message', function (event) {})
})
</script>

<style scoped lang="scss">
.match-details {
  display: flex;
  flex-direction: column;
  width: 375px;
  border-radius: 8px;
  height: 750px;
  max-height: calc(100vh - 220px);
  overflow: hidden;
  position: sticky;
  top: 200px;
  z-index: 10;
  align-self: flex-start;
  background: $bg-card;
  border: 1px solid $border-color;
}

// 隐藏浏览器滚动条
.match-details::-webkit-scrollbar {
  display: none;
}

// 卡片头部 - 与 LiveCard 保持一致
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  background: $bg-card;
  border-bottom: 1px solid $border-color;
  
  .header-tabs {
    display: flex;
    
    .tab-item {
      padding: 14px 20px;
      color: $text-secondary;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      position: relative;
      transition: all 0.3s ease;
      border-bottom: 2px solid transparent;
      
      &:hover {
        color: $text-primary;
      }
      
      &.active {
        color: $color-primary;
        font-weight: 600;
        font-size: 15px;
        border-bottom-color: $color-primary;
      }
    }
  }
  
  .header-link {
    padding: 14px 20px;
    color: $text-secondary;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      color: $color-primary;
    }
  }
}

// 播放器容器 - 与 LiveCard 保持一致
.player-container {
  background: #1a1a1a;
  height: 280px;
  position: relative;
  
  .player-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .player-frame {
      width: 100%;
      height: 100%;
      border: none;
    }
    
    // 暂无内容状态 - 与 LiveCard 保持一致
    .no-content-state {
      width: 100%;
      height: 100%;
      background: #1a1a1a;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      
      .no-content-container {
        display: flex;
        align-items: center;
        justify-content: center;
        
        .no-content-border {
          border: 2px solid $color-primary;
          border-radius: 8px;
          padding: 12px 24px;
          background: transparent;
          position: relative;
          
          // 添加轻微的主题色发光效果
          &::before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            bottom: -1px;
            background: linear-gradient(45deg, $color-primary, $color-primary, $color-primary);
            border-radius: 8px;
            z-index: -1;
            opacity: 0.3;
          }
          
          .no-content-text {
            color: $color-primary;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0.5px;
            text-align: center;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

.tab-container {
  display: flex;
  // justify-content: space-around;
  padding: 10px 0;
  background-color: $bg-card;
  border-top: 1px solid $border-color;
}

.tab {
  position: relative;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  color: $text-secondary;
  text-align: center;
}

.tab.active {
  color: $color-primary;
  font-weight: bold;
}

.underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 2px;
  background-color: $color-primary;
  border-radius: 1px;
}
.chat {
  background: $bg-card;
  padding: 0 10px 10px 10px;
  height: 354px;
  overflow-y: auto;
}

/* 隐藏滚动条 */
.chat::-webkit-scrollbar {
  display: none;
}
</style>
